import { render, staticRenderFns } from "./qaItem2.vue?vue&type=template&id=787159fd&"
import script from "./qaItem2.vue?vue&type=script&lang=js&"
export * from "./qaItem2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787159fd')) {
      api.createRecord('787159fd', component.options)
    } else {
      api.reload('787159fd', component.options)
    }
    module.hot.accept("./qaItem2.vue?vue&type=template&id=787159fd&", function () {
      api.rerender('787159fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qaItem2.vue"
export default component.exports